import {Button, Paper, Badge} from "@mantine/core";
import {
    TrademarkIcon,
    ClockIcon,
    CheckCircleIcon,
    XCircleIcon
} from "@phosphor-icons/react";
import {Link} from "react-router";
import withRouteErrorBoundary from "../../components/ErrorBoundary/withRouteErrorBoundary.tsx";
import Page from "../../components/Page/Page.tsx";
import Premium from "../../utils/Premium.ts";
import style from './Pricing.module.css';


function Comparison() {
    return (
        <Page>
            <title>Forge Subscription Plans</title>
            <div className="surface-0">
                <div style={{fontWeight: 'bold', fontSize: '3rem', marginBottom: '1rem', textAlign: 'center'}}>Pricing Plans</div>
                <div style={{fontSize: '1.25rem', marginBottom: '1.5rem', textAlign: 'center', lineHeight: 1.5}}>Unlock the full potential with a subscription, or try out our tools for free</div>

                <div style={{overflowX: 'auto'}}>
                    <table className={style.table}>
                        <thead>
                        <tr>
                            <td style={{padding: '0.75rem'}}>
                                <div style={{fontSize: '1.875rem', marginBottom: '0.5rem'}}>Pricing</div>
                                <span></span></td>
                            <td style={{padding: '0.75rem', textAlign: 'center'}}>
                                <div style={{fontSize: '1.25rem', fontWeight: 500, marginBottom: '0.75rem'}}>Basic</div>
                                <div style={{marginBottom: '0.75rem'}}><span style={{fontSize: '1.875rem'}}>Free</span></div>
                                <Link to="/"><Button>Use for free</Button></Link>
                            </td>
                            <td style={{padding: '0.75rem', textAlign: 'center'}}>
                                <div style={{fontSize: '1.25rem', fontWeight: 500, marginBottom: '0.75rem'}}>Premium</div>
                                <div style={{marginBottom: '0.75rem'}}><span style={{fontSize: '1.875rem'}}>15M</span> /year</div>
                                <Link to="/subscribe"><Button>Subscribe now</Button></Link>
                            </td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td colSpan={3}><h4 style={{margin: 0, textAlign: 'center'}}>Bounty Hunting</h4></td>
                        </tr>
                        <tr>
                            <td>Active Contracts</td>
                            <td style={{color: 'var(--mantine-color-dimmed)'}}>Up to <span>{Premium.ACTIVE_CONTRACTS}</span></td>
                            <td>Unlimited</td>
                        </tr>
                        <tr>
                            <td>Target Heatmap</td>
                            <td><IconYes/></td>
                            <td><IconYes/></td>
                        </tr>
                        <tr>
                            <td>Tavern Networks</td>
                            <td><IconYes/></td>
                            <td><IconYes/></td>
                        </tr>
                        <tr>
                            <td>Report Sighted Targets</td>
                            <td><IconYes/></td>
                            <td><IconYes/></td>
                        </tr>
                        <tr>
                            <td>Best Scans from Current Location</td>
                            <td><IconNo/></td>
                            <td><IconYes/></td>
                        </tr>
                        <tr>
                            <td>Custom Zones <Planned/></td>
                            <td><IconNo/></td>
                            <td><IconYes/></td>
                        </tr>
                        <tr>
                            <td>Copy-paste Import for Contract Details</td>
                            <td><IconNo/></td>
                            <td><IconYes/></td>
                        </tr>
                        <tr>
                            <td colSpan={3}><h4 style={{margin: 0, textAlign: 'center'}}>Hyper Routes</h4></td>
                        </tr>
                        <tr>
                            <td>Saved Routes</td>
                            <td style={{color: 'var(--mantine-color-dimmed)'}}>Up to <span>{Premium.HYPER_ROUTES}</span></td>
                            <td>Unlimited</td>
                        </tr>
                        <tr>
                            <td>Exclude Systems</td>
                            <td><IconNo/></td>
                            <td><IconYes/></td>
                        </tr>
                        <tr>
                            <td>Gravity well awareness</td>
                            <td><IconYes /></td>
                            <td><IconYes /></td>
                        </tr>
                        <tr>
                            <td colSpan={3}><h4 style={{margin: 0, textAlign: 'center'}}>Cargo Calculators</h4></td>
                        </tr>
                        <tr>
                            <td>Cargo and Fitout Calculators</td>
                            <td><IconYes/></td>
                            <td><IconYes/></td>
                        </tr>
                        <tr>
                            <td>Save Fitouts / Cargo Loadouts</td>
                            <td style={{color: 'var(--mantine-color-dimmed)'}}>Up to <span>{Premium.FITOUTS_SAVED}</span> each</td>
                            <td>Unlimited</td>
                        </tr>
                        <tr>
                            <td>Share with others</td>
                            <td><IconYes /></td>
                            <td><IconYes /></td>
                        </tr>
                        <tr>
                            <td>Copy-paste Import for Cargo</td>
                            <td><IconNo/></td>
                            <td><IconYes/></td>
                        </tr>
                        <tr>
                            <td colSpan={3}><h4 style={{margin: 0, textAlign: 'center'}}>Image Hosting</h4></td>
                        </tr>
                        <tr>
                            <td>Hosting Images</td>
                            <td><IconNo /></td>
                            <td style={{color: 'var(--mantine-color-dimmed)'}}>Up to <span>{Premium.IMAGE_HOSTING}</span> MB</td>
                        </tr>
                        <tr>
                            <td>Accepted Formats</td>
                            <td><IconNo /></td>
                            <td style={{color: 'var(--mantine-color-dimmed)'}}>JPG, PNG, GIF, WEBP</td>
                        </tr>
                        <tr>
                            <td>Image Optimization</td>
                            <td><IconNo /></td>
                            <td><IconYes /></td>
                        </tr>
                        <tr>
                            <td colSpan={3}><h4 style={{margin: 0, textAlign: 'center'}}>Vendors</h4></td>
                        </tr>
                        <tr>
                            <td>Search vendors and wares</td>
                            <td><IconYes /></td>
                            <td><IconYes /></td>
                        </tr>
                        <tr>
                            <td>Vendor and ware details</td>
                            <td><IconYes /></td>
                            <td><IconYes /></td>
                        </tr>
                        <tr>
                            <td>Maps</td>
                            <td><IconYes /></td>
                            <td><IconYes /></td>
                        </tr>
                        <tr>
                            <td colSpan={3}><h4 style={{margin: 0, textAlign: 'center'}}>Other tools</h4></td>
                        </tr>
                        <tr>
                            <td>Discord Timestamp Generator</td>
                            <td><IconYes/></td>
                            <td><IconYes/></td>
                        </tr>
                        <tr>
                            <td>GNS Archive</td>
                            <td><IconYes /></td>
                            <td><IconYes /></td>
                        </tr>
                        <tr>
                            <td>Asteroid Prospecting <New /></td>
                            <td><IconNo /></td>
                            <td><IconYes /></td>
                        </tr>
                        <tr>
                            <td>Vision Simulator</td>
                            <td><IconNo/></td>
                            <td><IconYes/></td>
                        </tr>
                        <tr>
                            <td>Interactive Map (Beta)</td>
                            {/*<td style={{color: 'var(--mantine-color-dimmed)'}}>Limited</td>*/}
                            <td><IconNo /></td>
                            <td><IconWIP/></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <Paper shadow="xs" p="md" withBorder style={{marginTop: '1rem'}}>
                <h2 id="faq" style={{textAlign: 'center', margin: 0}}>Frequently Asked Questions</h2>
                <div className="grid grid-nogutter">
                    <Question title="Is there a lifetime option?" answer="No, there is no one-off payment option, subscription has to be paid annually." />
                    <Question title="Can i buy licenses for my faction members?" answer="There are now multiple ways to purchase and gift subscriptions to other players, including a license management for your faction! Check out the subscription page for more details." />
                    <Question title="What happens if my subscription expires and i'm over the limits?" answer="You will not lose any data, but you'll need to remove some entries (or complete some contracts) in order to add new ones" />
                    <Question title="What happens if i receive a gift or voucher when i'm already subscribed?" answer="If someone gifts you a subscription or you redeem a voucher the new license will be automatically applied to your account once your current subscription expires." />
                </div>
            </Paper>
        </Page>
    )
}


const IconYes = () => <CheckCircleIcon size={16} color="green" style={{marginRight: '0.5rem'}}/>;
const IconNo = () => <XCircleIcon size={16} color="gray" style={{marginRight: '0.5rem'}}/>;
const IconLimit = () => <CheckCircleIcon size={16} color="orange" style={{marginRight: '0.5rem'}} title="With some limitations"/>;
const IconWIP = () => <ClockIcon size={16} color="blue" style={{marginRight: '0.5rem'}} title="Work in progress"/>;

const SoonTM = () => <Badge color="gray" className={style.chip}>Soon <TrademarkIcon /></Badge>;
const Planned = () => <Badge color="dark" className={style.chip}>Planned</Badge>;

const New = () => <Badge variant="primary" className={style.chip}>New</Badge>;

const Question = ({title, answer}) => {
    return (
        <div className="col-12 md:col-6 lg:col-4 p-5">
            <div style={{fontWeight: 500, fontSize: '1.25rem', marginBottom: '0.75rem'}}>{title}</div>
            <p style={{lineHeight: 1.5, margin: 0}}>{answer}</p></div>
    )
}

export default withRouteErrorBoundary(Comparison);
export {IconYes, Planned, SoonTM, New};
